/* tslint:disable */
/* eslint-disable */
/**
 * external-information-requests
 * Medicaid Pending document requests to family members, with the staff workspace and the family portal
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface PortalFacility
 */
export interface PortalFacility {
    /**
     * 
     */
    name: string;
    /**
     * 
     */
    phone: string | null;
    /**
     * 
     */
    logo_url: string | null;
}

/**
 * Check if a given object implements the PortalFacility interface.
 */
export function instanceOfPortalFacility(value: object): value is PortalFacility {
    if (!('name' in value) || value['name'] === undefined) return false;
    if (!('phone' in value) || value['phone'] === undefined) return false;
    if (!('logo_url' in value) || value['logo_url'] === undefined) return false;
    return true;
}

export function PortalFacilityFromJSON(json: any): PortalFacility {
    return PortalFacilityFromJSONTyped(json, false);
}

export function PortalFacilityFromJSONTyped(json: any, ignoreDiscriminator: boolean): PortalFacility {
    if (json == null) {
        return json;
    }
    return {
        
        'name': json['name'],
        'phone': json['phone'],
        'logo_url': json['logo_url'],
    };
}

export function PortalFacilityToJSON(json: any): PortalFacility {
    return PortalFacilityToJSONTyped(json, false);
}

export function PortalFacilityToJSONTyped(value?: PortalFacility | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'name': value['name'],
        'phone': value['phone'],
        'logo_url': value['logo_url'],
    };
}

